// AI-CONTEXT: See docs/features/updates-log.md

import formatUpdateDate from '../../helpers/updates/formatUpdateDate'

/**
 * Eén uitgelichte update als brede kaart bovenaan de Updates-pagina.
 *
 * De hele kaart is klikbaar, want hij ziet eruit als één ding. Zou alleen de
 * titel werken, dan is 'Lees verder' een uitnodiging die niet ingelost wordt.
 * Met de tab-toets kom je bij de knop in de kop — dat is de toegankelijke
 * ingang, en die is er precies één.
 *
 * Die knop zit BINNEN de h3 en niet andersom. Een kop binnen een knop is
 * ongeldige HTML waar React niet voor waarschuwt, en ARIA plat de kinderen van
 * een knop tot één naam: de kop is dan geen kop meer en niemand kan er nog met
 * de H-toets langs.
 * AI-CONTEXT: See docs/pitfalls.md#ui-heading-inside-button-stops-being-a-heading
 *
 * @param {object} props
 * @param {import('../../helpers/updates/isValidUpdate').Update} props.update - Update met een geldig highlight-blok
 * @param {(id: string) => void} props.onOpen - Wordt aangeroepen met het id van de update
 */
const FeaturedUpdateCard = ({ update, onOpen }) => {

  // Hooks
  const datum = formatUpdateDate(update.date)

  // JSX
  return (
    <article className="featured-update-card" onClick={() => onOpen(update.id)}>

      <img
        className="featured-update-image"
        src={`${process.env.PUBLIC_URL}/updates/${update.highlight.image}`}
        alt={update.highlight.imageAlt}
      />

      <div className="featured-update-body">
        <div className="featured-update-date">{datum}</div>
        <h3>
          <button type="button" onClick={() => onOpen(update.id)}>
            {update.title}
          </button>
        </h3>
        <p>{update.body}</p>
        <span className="featured-update-more" aria-hidden="true">Lees verder →</span>
      </div>

    </article>
  )
}

export default FeaturedUpdateCard
